/**
 * Integrytas Group — DDM (Demo Data Mirror)
 * DdmDemoBanner — full-width red banner shown at the top of every page while
 * the session is reading/writing the `demo` schema instead of production.
 * Rendered above the app header in TabManagerShell so it can't be mistaken
 * for the mimic-session pill (that's a narrower, amber, in-header notice).
 */

import { useTranslation } from 'react-i18next';
import { useDdmSchema } from '../../lib/ddm_mode';

export function DdmDemoBanner() {
  const { t } = useTranslation();
  const schema = useDdmSchema();
  if (schema !== 'demo') return null;

  return (
    <div
      role="status"
      className="flex h-7 shrink-0 items-center justify-center gap-2 bg-red-600 text-csm-xs font-semibold uppercase tracking-wide text-white"
    >
      {t('ddm.banner_active', 'Demo data — changes here do not affect production')}
    </div>
  );
}
